import { useCallback, useMemo } from "react";
import IDeal from "../../interfaces/IDeal";
import type IPipedriveOrganization from "../../interfaces/IPipedriveOrganization";
import type IProperty from "../../interfaces/IProperty";
import type { IBase64ScreenshotSet } from "../../services/propertyAiGradeApiService";
import type { IEstimates } from "../usePropertyEstimates";
import usePropertyScreenshots from "../usePropertyScreenshots";
import { buildBoeModelFromDeal } from "./boeMappings";
import { useBoeGenerator } from "./useBoeGenerator";

export function useDealBoeGenerator(deal: IDeal, property: IProperty | undefined) {
    const { screenshots, isLoading, isError, fetchScreenshots } = usePropertyScreenshots(property);
    const dataSource = useMemo(() => ({ data: screenshots, isLoading, isError, fetch: fetchScreenshots }), [screenshots, isLoading, isError, fetchScreenshots]);

    const buildModel = useCallback((screenshots: IBase64ScreenshotSet, estimates: IEstimates, initials: string, pipedriveOrganizations: IPipedriveOrganization[]) => {
        if (!property) return null;

        return buildBoeModelFromDeal(
            deal,
            property,
            estimates,
            screenshots.mapbox!,
            initials,
            pipedriveOrganizations,
        );
    }, [deal, property]);

    return useBoeGenerator(property, dataSource, buildModel);
}
